import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class PackingCategoryStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
